var map = {
	"./en.json": [
		"./projects/student/target/sis-components/annotated/lib/translate/en.json",
		456
	],
	"./fi.json": [
		"./projects/student/target/sis-components/annotated/lib/translate/fi.json",
		190
	],
	"./sv.json": [
		"./projects/student/target/sis-components/annotated/lib/translate/sv.json",
		250
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./projects/student/target/sis-components/annotated/lib/translate lazy recursive ^\\.\\/.*\\.json$ include: \\.json$";
module.exports = webpackAsyncContext;